var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0399 10.3889V13.3519C15.0399 13.7448 14.8839 14.1216 14.6062 14.3994C14.3286 14.6772 13.952 14.8333 13.5594 14.8333H3.19584C2.80318 14.8333 2.42661 14.6772 2.14896 14.3994C1.87131 14.1216 1.71533 13.7448 1.71533 13.3519V10.3889M4.67634 6.68519L8.3776 10.3889M8.3776 10.3889L12.0789 6.68519M8.3776 10.3889V1.5",
    stroke: "#1782D5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlue);
export default __webpack_public_path__ + "static/media/download_blue.dea4ed90ff68c73bc3801cab7645586b.svg";
export { ForwardRef as ReactComponent };